import React from 'react'
import { Box, List, ListItem, ListItemText, ListItemIcon } from '@mui/material'
import { useAuth } from '../../api/context/UserAuthContext'
import styled from 'styled-components'
import { MENU } from './menu'

const StyledBox = styled(Box)`
  width: 250px;
`

export const AdminMenu = () => {
  const { user } = useAuth()

  const allowLinks = MENU.filter(({ permission }) => user?.permission.includes(permission))

  return (
    <StyledBox display={{ xs: 'none', md: 'block' }}>
      <List>
        <Box>
          {allowLinks.map((link) => (
            <ListItem button component='a' href={link.url} key={link.text}>
              <ListItemIcon>{link.icon}</ListItemIcon>
              <ListItemText primary={`${link.text}`} />
            </ListItem>
          ))}
        </Box>
      </List>
    </StyledBox>
  )
}
